import { render, staticRenderFns } from "./BranchMenuEditor.vue?vue&type=template&id=2fb2cb1e&scoped=true&"
import script from "./BranchMenuEditor.vue?vue&type=script&lang=js&"
export * from "./BranchMenuEditor.vue?vue&type=script&lang=js&"
import style0 from "./BranchMenuEditor.vue?vue&type=style&index=0&id=2fb2cb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2cb1e",
  null
  
)

export default component.exports